  import { alertConstants } from "../constants";

export const alertActions = {
  prompt,
  spinner,
  success,
  error,
  clear,
};

function prompt(message) {
  return { type: alertConstants.PROMPT, message };
}

function spinner(message) {
  return { type: alertConstants.SPINNER, message };
}

function success(message) {
  return { type: alertConstants.SUCCESS, message };
}

function error(message) {
  return { type: alertConstants.ERROR, message };
}

function clear() {
  return { type: alertConstants.CLEAR };
}
